import ScatterEmitterComponent from "./celebrate-win/scatter-emitter-component";
import AnticipationComponent from "./matrix/anticipation-component";
import StackAddComponent from "./stack-feature/stack-add-component";
import MessagesComponent from "./messages/messages-component";
import G288BigWinComponent from "./bigwin/big-win-component";
import Components from "slotworks/components/components";
import { BigWinConfig } from "slotworks/config/component-config-schema";
import { CountMode } from "slotworks/components/bigwin/big-win-component";
import StackArrowsComponent from "./stack-feature/stack-arrows-component";

export default class G288Components {

    public static scatterEmitter: ScatterEmitterComponent;
    public static anticipation: AnticipationComponent;
    public static stackAdd: StackAddComponent;
    public static bigWin: G288BigWinComponent;
    public static stackArrows: StackArrowsComponent;

    public static init() {
        this.scatterEmitter = new ScatterEmitterComponent();
        this.anticipation = new AnticipationComponent();
        this.stackAdd = new StackAddComponent();
        this.stackArrows = new StackArrowsComponent();
        this.createBigWin();
    }

    private static createBigWin() {
        const config = Components.config.bigWin as BigWinConfig;
        const tiers = config.tiers;
        
        this.bigWin = new G288BigWinComponent();
        this.bigWin.countupMode = config.linearCountup ? CountMode.LINEAR : CountMode.TIERED;
        this.bigWin.upgrade = config.upgrade;

        if (tiers) {
            for (const tier of tiers) {
                this.bigWin.addWinTier(tier);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/components.ts